import React, { useState } from "react";

const testimonialData = [
  {
    text: "Gujco Mall has completely changed the way I shop for groceries. The variety and freshness are unmatched!",
    author: "Aman Kapoor",
    age: "39",
  },
  {
    text: "I love the clean layout and friendly staff at Gujco Mall. It’s my favorite place for weekly shopping.",
    author: "Neha Mishra",
    age: "30",
  },
  {
    text: "Whether it's fresh produce or pantry items, Gujco Mall always has what I need — and at great prices!",
    author: "Ravi Singh",
    age: "41",
  },
  {
    text: "Shopping at Gujco Mall is a breeze. The aisles are spacious and the product quality is excellent.",
    author: "Priya Chatterjee",
    age: "33",
  },
  {
    text: "I started ordering online from Gujco Mall, and the delivery is fast, reliable, and always fresh.",
    author: "Arjun Kulkarni",
    age: "29",
  },
  {
    text: "Thousands have discovered unbeatable freshness and value at Gujco Mall",
    author: "Sneha Patel",
    age: "35",
  },
];


export default function Testimonials() {
  const [start, setStart] = useState(0);
  const visibleCount = 2; // Show 2 at a time

  const nextSlide = () => {
    setStart((prev) =>
      prev + visibleCount >= testimonialData.length ? 0 : prev + visibleCount
    );
  };

  const prevSlide = () => {
    setStart((prev) =>
      prev - visibleCount < 0
        ? testimonialData.length - visibleCount
        : prev - visibleCount
    );
  };

  return (
    <section className="testimonial-section">
      <div className="testimonial-container">
        {/* Left Section */}
        <div className="testimonial-left">
          <h5 className="section-subtitle heading caveatFont">TESTIMONIAL</h5>
          <h4 className="section-title subheading">
            Thousands have trusted Gujco Mall for their everyday grocery needs.
          </h4>

          <div className="testimonial-slider-wrapper">
            {/* Left Arrow */}
            <button onClick={prevSlide} className="arrow-btn">
              &#8249;
            </button>

            {/* Slider */}
            <div className="testimonial-slider">
              {testimonialData.map((item, i) => (
                <div
                  key={i}
                  className={`testimonial-box ${
                    i >= start && i < start + visibleCount ? "active" : ""
                  }`}
                >
                  <p>{item.text}</p>
                  <div className="testimonial-author">
                    <strong>{item.author},</strong>{" "}
                    <span>{item.age && item.age}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Right Arrow */}
            <button onClick={nextSlide} className="arrow-btn">
              &#8250;
            </button>
          </div>
        </div>

        {/* Right Section (Image) */}
        <div className="testimonial-right">
          <img
            src="/assets/new/20220830_123314-02_1.jpeg"
            alt="Patient"
          />
        </div>
      </div>
    </section>
  );
}
